import MicroModal from 'micromodal'

let $modals = document.querySelectorAll('.js-modal')

if ($modals.length > 0) {
  MicroModal.init({
    disableScroll: true,
    awaitCloseAnimation: true,
    onClose: modal => {
      let $content = modal.querySelector('main')
      $content.parentNode.replaceChild($content.cloneNode(true), $content)
    }
  })
}



// WEBPACK FOOTER //
// ./src/js/_modal.js